import { render, staticRenderFns } from "./ModalEditTarifSematha.vue?vue&type=template&id=2a60e9b8&scoped=true&"
import script from "./ModalEditTarifSematha.vue?vue&type=script&lang=js&"
export * from "./ModalEditTarifSematha.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditTarifSematha.vue?vue&type=style&index=0&id=2a60e9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60e9b8",
  null
  
)

export default component.exports